import { useImpression } from "@/lib/analytics";

const Offer = () => {
  const sectionRef = useImpression<HTMLElement>("schedule_view", { section: "offer" });

  return (
    <section ref={sectionRef} id="offer" className="py-24 md:py-32 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-[10px] tracking-[0.35em] uppercase text-accent font-medium">
            Preferred Rates
          </span>
          <h2 className="font-display text-4xl md:text-5xl mt-4 text-foreground text-balance">
            Considered Care. <span className="italic">Preferred</span> Rates.
          </h2>
          <p className="mt-6 text-muted-foreground font-light leading-relaxed">
            Blepharoplasty with Dr Vahe is available at our London suite, with preferred
            promotional rates for upper and combined eyelid surgery.
          </p>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-6 md:gap-10 mb-20 text-center">
          <div className="bg-card border border-border rounded-2xl px-8 py-6 shadow-soft">
            <p className="text-[10px] tracking-[0.35em] uppercase text-muted-foreground">Availability</p>
            <p className="font-display text-3xl md:text-4xl text-foreground mt-2">By appointment</p>
          </div>
          <div className="font-display text-2xl text-accent italic">·</div>
          <div className="bg-card border border-border rounded-2xl px-8 py-6 shadow-soft">
            <p className="text-[10px] tracking-[0.35em] uppercase text-muted-foreground">Consultation</p>
            <p className="font-display text-3xl md:text-4xl text-foreground mt-2">Personal</p>
          </div>
          <div className="font-display text-2xl text-accent italic">·</div>
          <div className="bg-card border border-border rounded-2xl px-8 py-6 shadow-soft">
            <p className="text-[10px] tracking-[0.35em] uppercase text-muted-foreground">Aftercare</p>
            <p className="font-display text-3xl md:text-4xl text-foreground mt-2">Included</p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-4 md:gap-6 max-w-5xl mx-auto">
          <div className="bg-secondary p-10 md:p-12 rounded-3xl">
            <p className="text-[10px] tracking-[0.35em] uppercase text-accent font-medium">
              Procedure One
            </p>
            <h3 className="font-display text-3xl md:text-4xl mt-4 text-foreground">
              Upper Blepharoplasty
            </h3>
            <div className="flex items-baseline gap-4 mt-8">
              <span className="font-display text-5xl text-foreground">£2,300</span>
              <span className="text-base line-through opacity-40 italic">£3,200</span>
            </div>
            <p className="mt-3 text-sm text-accent font-medium tracking-wide">
              You save £900
            </p>
            <ul className="mt-8 space-y-3 text-sm text-foreground/80 font-light">
              <li className="flex gap-3"><span className="text-accent">·</span> Pre-operative consultation included</li>
              <li className="flex gap-3"><span className="text-accent">·</span> Local anaesthesia, 45–60 minutes</li>
              <li className="flex gap-3"><span className="text-accent">·</span> Stitch removal & follow-up care</li>
            </ul>
          </div>

          <div className="bg-primary text-primary-foreground p-10 md:p-12 rounded-3xl shadow-elegant">
            <p className="text-[10px] tracking-[0.35em] uppercase text-accent font-medium">
              Most Requested
            </p>
            <h3 className="font-display text-3xl md:text-4xl mt-4">
              Upper <span className="italic">&</span> Lower
            </h3>
            <div className="flex items-baseline gap-4 mt-8">
              <span className="font-display text-5xl">£3,100</span>
              <span className="text-base line-through opacity-50 italic">£4,200</span>
            </div>
            <p className="mt-3 text-sm text-accent font-medium tracking-wide">
              You save £1,100
            </p>
            <ul className="mt-8 space-y-3 text-sm font-light opacity-90">
              <li className="flex gap-3"><span className="text-accent">·</span> Comprehensive periorbital restoration</li>
              <li className="flex gap-3"><span className="text-accent">·</span> Advanced micro-suturing technique</li>
              <li className="flex gap-3"><span className="text-accent">·</span> Full perioperative concierge care</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Offer;
